"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var RowSelect_exports = {};
__export(RowSelect_exports, {
  default: () => RowSelect_default
});
module.exports = __toCommonJS(RowSelect_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.10003 17.4999C3.10003 18.2731 3.72683 18.8999 4.50003 18.8999H6.64288C6.97425 18.8999 7.24288 19.1685 7.24288 19.4999C7.24288 19.8313 6.97425 20.0999 6.64288 20.0999H4.50003C3.06409 20.0999 1.90003 18.9358 1.90002 17.4999L1.90002 15.9285C1.90002 15.5971 2.16865 15.3285 2.50002 15.3285C2.8314 15.3285 3.10002 15.5971 3.10002 15.9285L3.10003 17.4999ZM2.50002 14.1713C2.16865 14.1713 1.90002 13.9027 1.90002 13.5713L1.90002 10.4285C1.90002 10.0971 2.16865 9.82847 2.50002 9.82847C2.8314 9.82847 3.10002 10.0971 3.10002 10.4285L3.10002 13.5713C3.10002 13.9027 2.8314 14.1713 2.50002 14.1713ZM2.50002 8.67133C2.16865 8.67133 1.90002 8.4027 1.90002 8.07133L1.90002 6.4999C1.90002 5.06396 3.06408 3.8999 4.50002 3.8999L6.64288 3.8999C6.97425 3.8999 7.24288 4.16853 7.24288 4.4999C7.24288 4.83127 6.97425 5.0999 6.64288 5.0999H4.50002C3.72683 5.0999 3.10002 5.7267 3.10002 6.4999V8.07133C3.10002 8.4027 2.8314 8.67133 2.50002 8.67133ZM9.25717 4.4999C9.25717 4.16853 9.5258 3.8999 9.85717 3.8999L14.1429 3.8999C14.4743 3.8999 14.7429 4.16853 14.7429 4.4999C14.7429 4.83127 14.4743 5.0999 14.1429 5.0999H9.85717C9.5258 5.0999 9.25717 4.83127 9.25717 4.4999ZM9.25717 19.4999C9.25717 19.1685 9.5258 18.8999 9.85717 18.8999H14.1429C14.4743 18.8999 14.7429 19.1685 14.7429 19.4999C14.7429 19.8313 14.4743 20.0999 14.1429 20.0999H9.85717C9.5258 20.0999 9.25717 19.8313 9.25717 19.4999ZM16.7572 4.4999C16.7572 4.16853 17.0258 3.8999 17.3572 3.8999H19.5C20.936 3.8999 22.1 5.06396 22.1 6.4999V8.07133C22.1 8.4027 21.8314 8.67133 21.5 8.67133C21.1687 8.67133 20.9 8.4027 20.9 8.07133V6.4999C20.9 5.7267 20.2732 5.0999 19.5 5.0999L17.3572 5.0999C17.0258 5.0999 16.7572 4.83127 16.7572 4.4999ZM16.7572 19.4999C16.7572 19.1685 17.0258 18.8999 17.3572 18.8999H19.5C20.2732 18.8999 20.9 18.2731 20.9 17.4999V15.9285C20.9 15.5971 21.1687 15.3285 21.5 15.3285C21.8314 15.3285 22.1 15.5971 22.1 15.9285V17.4999C22.1 18.9358 20.936 20.0999 19.5 20.0999H17.3572C17.0258 20.0999 16.7572 19.8313 16.7572 19.4999ZM21.5 14.1713C21.1687 14.1713 20.9 13.9027 20.9 13.5713V10.4285C20.9 10.0971 21.1687 9.82847 21.5 9.82847C21.8314 9.82847 22.1 10.0971 22.1 10.4285V13.5713C22.1 13.9027 21.8314 14.1713 21.5 14.1713ZM6.5 15.9998C5.94772 15.9998 5.5 15.5521 5.5 14.9998L5.5 8.99981C5.5 8.44752 5.94772 7.99981 6.5 7.99981H9.5C10.0523 7.99981 10.5 8.44752 10.5 8.99981V14.9998C10.5 15.5521 10.0523 15.9998 9.5 15.9998H6.5ZM13.5 14.9998C13.5 15.5521 13.9477 15.9998 14.5 15.9998H17.5C18.0523 15.9998 18.5 15.5521 18.5 14.9998V8.99981C18.5 8.44752 18.0523 7.99981 17.5 7.99981H14.5C13.9477 7.99981 13.5 8.44752 13.5 8.99981V14.9998Z",
      fill: "currentColor"
    }
  )
);
const SvgRowSelect = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var RowSelect_default = SvgRowSelect;
